<template>
  <div class="container">
    <a-breadcrumb separator=">">
      <a-breadcrumb-item href="" @click.native="() => $router.push('/')">首页</a-breadcrumb-item>
      <a-breadcrumb-item>我的预约</a-breadcrumb-item>
    </a-breadcrumb>

    <div class="select-box">
      <div class="select-hospital">
        <div class="menu-header">
          <img v-if="userInfo.gender == '1'" src="@/assets/img/man.png" alt="">
          <img v-else src="@/assets/img/woman.png" alt=""></img>
          <div class="name">{{ userInfo.userName }} - {{ userInfo.gender == '1' ? '男' : '女' }}</div>
        </div>

        <div v-for="(item, index) in selcetList" :key="index">
          <div class="hospital-title">
            <img :src="item.img" alt="" />
            <span> {{ item.name }}</span>
          </div>
          <div class="hospital-item" v-for="(item, index) in item.hospitalList" :key="item.id"
            :class="[item.id == actived ? 'actived' : '']" @click="onChangeHospital(item)">
            {{ item.name }}
            <a-icon type="right" :class="[item.id == actived ? 'displayShow' : 'displayNone']" />
          </div>
        </div>
      </div>
      <div class="select-department">
        <!--预约挂号-->
        <div class="list" v-if="actived == 0">
          <div class="list-item" v-for="item in listData" :key="item.appointmentId">
            <div class="list-item-top">
              <div class="name">{{ item.patientName }}</div>
              <div class="status" :style="{ color: status[item.status].color }">
                {{ item.status | reservationStatusFilter }}
              </div>
            </div>
            <div class="list-item-content">
              <div>就诊院区：{{ item.campusName }}</div>
              <div>预约科室：{{ item.officeName }}</div>
              <div>预约医生：{{ item.doctorName ? item.doctorName : item.officeName + '普通门诊' }}</div>
              <div>
                预约时间：<span class="fontColor">
                  {{ item.date }}
                  {{ item.dutyType == '1' ? '上午' : '下午' }}
                  {{ item.sourceTime }}</span>
              </div>
              <div>挂号费用：<span class="fontColor">{{ item.expense }}元</span></div>
              <div class="pwd">取号密码：<span class="fontColor">{{ item.passwordNumber }}</span></div>
            </div>
            <a-button class="btn" type="primary" v-if="item.status == 1" :disabled="disabledTime(item.date)"
              @click="onCancel(item)">取消预约</a-button>
          </div>
          <a-pagination v-if="!isNo" show-quick-jumper v-model="currentpage" :total="total" @change="onChange" />
        </div>
        <!--体检预约-->
        <div class="list" v-if="actived == 1">
          <div class="list-item" v-for="(item) in listData1" :key="item.id">
            <div class="list-item-top">
              <div class="name">{{ item.name }}</div>
              <div class="status" :style="{ color: status1[item.status].color }">
                {{ status1[item.status].name }}
              </div>
            </div>
            <div class="list-item-content">
              <div>体检院区：{{ item.campusName }}</div>
              <div>体检套餐：{{ item.comboName }}</div>
              <div>
                就诊日期：<span class="fontColor">
                  {{ item.appointmentTime }}&nbsp;&nbsp;{{ item.timePeriod || '' }}
                </span>
              </div>
              <div>
                基础项目：
                <span>{{ item.basicsItem }}</span>
              </div>
              <div>
                选择项目：
                <span>{{ item.selectItem }}</span>
              </div>
              <div>
                自选套餐：
                <span v-for="(item, index) in item.additionalComboList" :key="index">{{ item.comboName }}</span>
              </div>
            </div>
            <a-button class="btn" type="primary" v-if="item.status == 0" @click="onCancelReserve(item)">取消预约</a-button>
          </div>
          <a-pagination v-if="!isNo" show-quick-jumper v-model="currentpage1" :total="total1" @change="onChange1" />
        </div>
        <!-- 内镜预约 -->
        <div class="list" v-if="actived == 2">
          <div class="list-item" v-for="item in endoscopyList" :key="item.endoscopyId">
            <div class="list-item-top">
              <div class="name">{{ item.name }}</div>
              <div class="status" :style="{ color: status1[item.status].color }">
                {{ status1[item.status].name }}
              </div>
            </div>
            <div class="list-item-content">
              <div>就诊院区：浙江大学医学院{{ item.campusName }}</div>
              <div>内镜项目：{{ item.projectName }}</div>
              <div>
                就诊日期：<span class="fontColor">
                  {{ item.recordTime }}
                </span>
              </div>
              <!-- <div>
                编号：<span class="fontColor">{{ item.number }}号</span>
              </div> -->
              <!-- <div>挂号费用：<span class="fontColor">80.00元</span></div> -->
            </div>
            <a-button class="btn" type="primary" v-if="item.status == '0'" :disabled="disabledTime(item.recordTime)"
              @click="onCancelEndoscopy(item)">取消预约
            </a-button>

          </div>
          <a-pagination v-if="!isNo" show-quick-jumper v-model="currentpage2" :total="total2" @change="onChange2" />
        </div>
        <!-- 就诊人管理 -->
        <div class="list" v-if="actived == 7">
          <a-button type="primary" @click="onAddPatient" style="margin: 10px 0">新增就诊人</a-button>
          <div class="list-item" v-for="item in listPatient" :key="item.id">
            <div class="list-item-top">
              <div class="name">{{ item.name }}</div>
            </div>
            <div class="list-item-content">
              <div class="status">
                证件类型：{{ cardType[item.cardType] }}
              </div>
              <div>证件号：{{ item.idNumber }}</div>
              <div>手机号：{{ item.phone }}</div>
            </div>
            <a-button class="btn" @click="onEditPatient(item)">编辑</a-button>
            <a-button class="btn" type="danger" @click="onDelPatient(item)">删除</a-button>
          </div>
          <!-- <a-pagination v-if="!isNo" show-quick-jumper v-model="currentpage" :total="total" @change="onChange" /> -->
        </div>


        <!-- 服务工单 -->
        <div class="list" v-else-if="actived == 8">
          <a-tabs v-model="serviceStatus" size="small" @change="callback">
            <a-tab-pane :key="0" tab="已处理">
            </a-tab-pane>
            <a-tab-pane :key="1" tab="未处理">
            </a-tab-pane>
          </a-tabs>

          <a-button type="primary" @click="onAddService" style="margin: 10px 0">新增服务工单</a-button>
          <div class="list-item" v-for="item in serviceList" :key="item.id">
            <div class="list-item-top">
              <div class="name">服务工单号:{{ item.id }}</div>
            </div>
            <div class="list-item-content">
              <div class="status">
                状态：{{ item.status | statusFilter }}
              </div>
              <div>留言内容：{{ item.content }}</div>
              <div>提交时间：{{ item.createTime }}</div>
            </div>
            <a-button class="btn" type="danger" @click="deleteItem(item.id)">删除</a-button>
          </div>
          <a-pagination v-if="!isNo" show-quick-jumper v-model="pageNum3" :total="serviceTotal"
            @change="servicePageChange" />
        </div>

        <!-- 个人信息 -->
        <div class="list" v-if="actived == 9">
          <div class="list-item">
            <div class="list-item-top">
              <div class="name">{{ userInfoDetail.userName }}</div>
            </div>

            <div class="list-item-content">
              <div>性别：{{ userInfoDetail.gender | genderFilter }}</div>
              <div>出生日期：{{ userInfoDetail.birthday }}</div>
              <div class="status">
                证件类型：{{ userInfoDetail.certificateType | certificateTypeFilter }}
              </div>
              <div v-if="userInfoDetail.certificateType == '0'">身份证号：{{ userInfoDetail.idCard }}</div>
              <div v-else>证件号：{{ userInfoDetail.passport }}</div>
              <div>手机号：{{ userInfoDetail.phone }}</div>
              <div>国籍：{{ countryFormatter(userInfoDetail.country) }}</div>
              <div>婚姻状况：{{ userInfoDetail.maritalStatus | maritalStatusFormatter }}</div>
              <div>人员类型：{{ userInfoDetail.userType | userTypeFilter }}</div>
              <!-- <div>职称：{{ userInfoDetail.title }}</div> -->
              <div>所属单位：{{ userInfoDetail.unit }}</div>
              <div>学院部门：{{ userInfoDetail.dept }}</div>
              <div>邮箱：{{ userInfoDetail.email }}</div>
            </div>

            <a-button type="primary" @click="onUpdatedInfo" style="margin: 10px 20px">修改</a-button>

          </div>

        </div>

        <!--暂无数据-->
        <a-empty v-if="isNo" />
      </div>
    </div>
    <!--新增就诊人弹窗-->
    <a-modal title="就诊人" :visible="visible" centered @cancel="cancelVisible" :footer="null">
      <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="{ span: 6 }" :wrapper-col="{ span: 14 }">
        <a-form-model-item label="就诊人姓名" prop="patientName">
          <a-input v-model="form.patientName" placeholder="请输入" />
        </a-form-model-item>
        <a-form-model-item label="证件类型" prop="cardType">
          <a-select v-model="form.cardType" placeholder="请输入">
            <a-select-option value="0">身份证号</a-select-option>
            <a-select-option value="1">护照或通行证</a-select-option>
            <a-select-option value="100">户口本</a-select-option>
            <a-select-option value="16">外国人永久居留身份证</a-select-option>
            <a-select-option value="17">港澳台居民居住证</a-select-option>
            <a-select-option value="2">驾驶证</a-select-option>
            <a-select-option value="3">军官证</a-select-option>
            <a-select-option value="5">出生医学证</a-select-option>
            <a-select-option value="6">学生证</a-select-option>
            <a-select-option value="7">其他证件</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="证件号" prop="idCard">
          <a-input v-model="form.idCard" @change="getIdCardInfo" placeholder="请输入" />
        </a-form-model-item>
        <a-form-model-item label="性别" prop="gender">
          <a-select v-model="form.gender" placeholder="请输入">
            <a-select-option :value="1">男</a-select-option>
            <a-select-option :value="2">女</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="出生日期" prop="birthday">
          <a-date-picker v-model="form.birthday" @change="birthdayChange" />
        </a-form-model-item>
        <a-form-model-item label="手机号" prop="phone">
          <a-input v-model="form.phone" :maxLength="11" placeholder="请输入" />
        </a-form-model-item>

        <a-button type="primary" block @click="onSubmit">
          确认
        </a-button>

      </a-form-model>
    </a-modal>
    <!--新增服务工单-->
    <a-modal title="新增服务工单" :visible="isAddService" @cancel="cancelService" :footer="null">
      <a-form-model ref="serviceForm" :model="serviceForm" :rules="serviceRules" :label-col="{ span: 6 }"
        :wrapper-col="{ span: 14 }">
        <a-form-model-item label="留言" prop="content">
          <a-textarea v-model="serviceForm.content" :maxLength="200" placeholder="请输入留言内容，字数限制在200字以内" :rows="4" />
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 6, offset: 16 }">
          <a-button type="primary" @click="onSubmitService">
            确认
          </a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!--修改用户信息弹窗-->
    <a-modal title="修改用户信息" :visible="isUpdateUser" centered :maskClosable="false" :confirmLoading="confirmLoading"
      @ok="handleOk" @cancel="handleCancel">
      <a-form-model ref="updateRuleForm" :model="updateForm" :rules="updateRules" :label-col="{ span: 6 }"
        :wrapper-col="{ span: 14 }">
        <a-form-model-item label="姓名" prop="userName">
          <a-input v-model="updateForm.userName" placeholder="请输入" />
        </a-form-model-item>

        <a-form-model-item label="证件类型" prop="certificateType">
          <a-select v-model="updateForm.certificateType" placeholder="请选择">
            <a-select-option value="0">身份证</a-select-option>
            <a-select-option value="1">护照</a-select-option>
            <a-select-option value="8">港澳台通行证</a-select-option>
            <a-select-option value="2">其他</a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item v-if="updateForm.certificateType == '0'" label="身份证号" prop="idCard">
          <a-input v-model="updateForm.idCard" :maxLength="18" placeholder="请输入" />
        </a-form-model-item>


        <a-form-model-item v-else label="证件号" prop="passport">
          <a-input v-model="updateForm.passport" placeholder="请输入" />
        </a-form-model-item>

        <a-form-model-item label="手机号" prop="phone">
          <a-input v-model="updateForm.phone" disabled :maxLength="11" placeholder="请输入" />
        </a-form-model-item>


        <a-form-model-item label="性别" prop="gender">
          <a-select v-model="updateForm.gender" placeholder="请选择">
            <a-select-option value="1">男</a-select-option>
            <a-select-option value="2">女</a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="出生日期" prop="birthday">
          <a-date-picker v-model="updateForm.birthday" valueFormat="YYYY-MM-DD" format="YYYY-MM-DD" />
        </a-form-model-item>

        <a-form-model-item label="国籍" prop="country">
          <a-select show-search option-filter-prop="children" :filter-option="filterOption" v-model="updateForm.country"
            placeholder="请选择">
            <a-select-option v-for="item in countryOptions" :value="item.countryCode" :key="item.countryCode">{{
              item.countryName }}</a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="婚姻状况" prop="maritalStatus">
          <a-select v-model="updateForm.maritalStatus" placeholder="请选择">
            <a-select-option :value="1">已婚</a-select-option>
            <a-select-option :value="2">未婚</a-select-option>
            <a-select-option :value="3">离异</a-select-option>
          </a-select>
        </a-form-model-item>


        <a-form-model-item label="所属单位" prop="unit">
          <a-select v-model="updateForm.unit" placeholder="请选择">
            <a-select-option value="浙江大学">浙江大学</a-select-option>
            <a-select-option value="其他">其他</a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item v-if="updateForm.unit == '其他'" label="其他单位" prop="otherUnit">
          <a-input v-model="updateForm.otherUnit" placeholder="请输入" />
        </a-form-model-item>

        <a-form-model-item v-if="updateForm.unit.toString().includes('浙江大学')" label="学院部门" prop="dept">
          <a-input v-model="updateForm.dept" placeholder="请输入" />
        </a-form-model-item>

        <a-form-model-item label="人员类型" prop="userType">
          <a-select v-model="updateForm.userType" placeholder="请选择">
            <a-select-option v-for="item in userTypeOptions" :key="item.value" :value="item.value">{{
              item.label }}</a-select-option>
          </a-select>
        </a-form-model-item>

        <!--校外人员填写人员职称-->
        <!-- <a-form-model-item v-if="updateForm.userType == 4" label="人员职称" prop="title">
          <a-input v-model="updateForm.title" placeholder="请输入"/>
        </a-form-model-item> -->

        <!--在职、在校学生填写-->
        <a-form-model-item v-if="updateForm.userType == 1 || updateForm.userType == 2" label="所属校区" prop="college">
          <a-select v-model="updateForm.college" placeholder="请选择">
            <a-select-option v-for="(item, index) in collegeOptions" :key="index" :value="item.label">{{
              item.label }}</a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="邮箱地址" prop="email">
          <a-input v-model="updateForm.email" placeholder="请输入" />
        </a-form-model-item>

      </a-form-model>
    </a-modal>

  </div>
</template>

<script>
import {
  oppointmentRecord,
  userListAppointment,
  getEndoscopy,
  cancelOppointment,
  getEndoscopyCancel,
  cancelOppointmentV2,
} from "@/api/registration";

import {
  getListPatients,
  addPatient,
  editPatient,
  deletePatient,
  getPatients,
  getServiceListRequest,
  deleteServiceRequest,
  addServiceRequest,
  getUserDetail,
  updateUserInfo,
} from "@/api/bac";

import {
  getReserveList,
  getReserveCancel,
  getMemberUser,
  updateMemberUser,
  getCountryListRequest,
} from "@/api/medicalBooking";

import icon1 from "@/assets/img/icon_my1.png";
import icon2 from "@/assets/img/icon_my2.png";
import icon3 from "@/assets/img/icon_my3.png";
import { onUpdated } from "vue";
import base from "@/assets/base/base";
const isPhone = (_rule, value) => {
  const reg =
    /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
  if (!value) {
    return Promise.reject("请输入手机号");
  } else if (!reg.test(value)) {
    return Promise.reject("请输入正确的手机号");
  } else {
    return Promise.resolve();
  }
};
export default {
  data() {
    return {
      cardType: {
        0: "身份证",
        1: "护照或通行证",
        100: "户口本",
        16: "外国人永久居留身份证",
        17: "港澳台居民居住证",
        2: "驾驶证",
        3: "军官证",
        5: "出生医学证",
        6: "学生证",
        7: "其他证件",
      },
      isAddService: false,
      isUpdateUser: false,
      pageNum3: 1,
      isNo: false,
      serviceStatus: 0,
      serviceTotal: 0,
      serviceList: [],
      listPatient: [],
      countryOptions: [], //国籍列表
      serviceForm: {
        content: "",
      },
      form: {
        cardType: undefined,
        idCard: "",
        patientName: "",
        phone: "",
      },
      updateForm: {
        gender: "1",
        certificateType: "0",
        userType: "5",
        idCard: "",
        birthday: "",
        phone: "",
        college: "",
        country: "",
        jobNo: "",
        passport: "", //护照
        userName: "",
        unit: "", //单位
        otherUnit: "", //其他单位
        dept: "", //部门
        title: "", //职称
        email: "", //邮箱
        maritalStatus: 2,
      },
      updateRules: {
        userName: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur",
          },
        ],
        certificateType: [
          {
            required: true,
            message: "请选择证件类型",
            trigger: "change",
          },
        ],
        idCard: [
          {
            required: true,
            message: "请输入证件号",
            trigger: "change",
          },
        ],
        passport: [
          {
            required: true,
            message: "请输入证件号",
            trigger: "change",
          },
        ],
        phone: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "change",
          },
          {
            pattern:
              /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
            message: "请输入正确的手机号",
            trigger: "change",
          },
        ],
        gender: [
          {
            required: true,
            message: "请选择性别",
            trigger: "change",
          },
        ],
        country: [
          {
            required: true,
            message: "请选择国籍",
            trigger: "change",
          },
        ],
        maritalStatus: [
          {
            required: true,
            message: "请选择婚姻状况",
            trigger: "change",
          },
        ],
        birthday: [
          {
            required: true,
            message: "请选择出生日期",
            trigger: "change",
          },
        ],
        unit: [
          {
            required: true,
            message: "请选择所属单位",
            trigger: "change",
          },
        ],
        otherUnit: [
          {
            required: true,
            message: "请输入其他单位",
            trigger: "blur",
          },
        ],
        dept: [
          {
            required: true,
            message: "请输入部门",
            trigger: "blur",
          },
        ],
        title: [
          {
            required: true,
            message: "请选择职称",
            trigger: "change",
          },
        ],
        userType: [
          {
            required: true,
            message: "请选择人员类型",
            trigger: "change",
          },
        ],
        college: [
          {
            required: true,
            message: "请选择校区",
            trigger: "change",
          },
        ],
        email: [
          {
            required: false,
            message: "请输入邮箱",
            trigger: "blur",
          },
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: "blur",
          },
        ],
      },
      rules: {
        patientName: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur",
          },
        ],
        cardType: [
          {
            required: true,
            message: "请选择证件类型",
            trigger: "change",
          },
        ],
        idCard: [
          {
            required: true,
            message: "请输入证件号",
            trigger: "change",
          }
        ],
        phone: [{ required: true, validator: isPhone, trigger: "change" }],
        gender: [
          {
            required: true,
            message: "请选择性别",
            trigger: "change",
          },
        ],
        birthday: [
          {
            required: true,
            message: "请选择出生日期",
            trigger: "change",
          },
        ],
      },
      serviceRules: {
        content: [
          {
            required: true,
            message: "请输入留言内容",
            trigger: "blur",
          },
        ],
      },
      visible: false,
      icon1,
      icon2,
      icon3,
      currentpage: 1,
      total: 0,
      currentpage1: 1,
      total1: 0,
      currentpage2: 1,
      total2: 0,
      actived: 0,
      activedDepartment: 0,
      selcetList: [
        {
          name: "订单管理",
          img: icon1,
          hospitalList: [
            { id: 0, name: "挂号预约" },
            { id: 1, name: "体检预约" },
            // { id: 2, name: '内镜预约' }
          ],
        },
        {
          name: "健康档案",
          img: icon2,
          hospitalList: [
            { id: 3, name: "检验报告" },
            { id: 4, name: "检查报告" },
            { id: 5, name: "体检报告" },
          ],
        },
        {
          name: "更多设置",
          img: icon3,
          hospitalList: [
            { id: 6, name: "检后咨询" },
            { id: 7, name: "就诊人管理" },
            // { id: 8, name: "服务工单" },
            { id: 9, name: "个人信息" },
          ],
        },
      ],
      listData: [],
      listData1: [],
      status: {
        0: {
          name: "已取消",
          color: "#797979",
        },
        1: {
          name: "已预约",
          color: "#FF6600",
        },
        2: {
          name: "已挂号",
          color: "#52c41a",
        },
        3: {
          name: "已取消",
          color: "#797979",
        },
        4: {
          name: "已爽约",
          color: "#f5222d",
        },
      },
      status1: {
        0: {
          name: "已预约",
          color: "#FF6600",
        },
        1: {
          name: "已取消",
          color: "#797979",
        },
      },
      endoscopyList: [],
      isNo: false, //暂无数据
      userInfo: {},
      userInfoDetail: {}, //个人信息
      userTypeOptions: [
        {
          label: "在职",
          value: "1",
        },
        {
          label: "在校学生",
          value: "2",
        },
        {
          label: "退休",
          value: "3",
        },
        {
          label: "校外人员",
          value: "4",
        },
        {
          label: "其他",
          value: "5",
        },
      ],
      collegeOptions: [
        {
          label: "紫金港校区",
        },
        {
          label: "玉泉校区",
        },
        {
          label: "华家池校区",
        },
        {
          label: "西溪校区",
        },
      ],
      confirmLoading: false,
    };
  },
  computed: {
    isUpdateUserTime() {
      return this.$store.state.login.isUpdateUserTime;
    },
  },
  watch: {
    "$route.query.queryActived": {
      handler(val) {
        this.actived = val || 0;
        const data = {
          id: Number(this.actived),
        };
        this.userInfo =
          sessionStorage.getItem("userInfo") &&
          JSON.parse(sessionStorage.getItem("userInfo"));
        this.onChangeHospital(data);
      },
      immediate: true,
      deep: true,
    },
    isUpdateUserTime: {
      handler(val) {
        this.getUserInfo();
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    this.userInfo =
      sessionStorage.getItem("userInfo") &&
      JSON.parse(sessionStorage.getItem("userInfo"));
    this.getCountryList();
    this.getMemberUserInfo();
  },
  methods: {
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    //根据身份证获取生日和性别
    getIdCardInfo() {
      if (base.isCardVerify(this.form.idCard)) {
        let birthday = base.getBirthdayByIdCard(this.form.idCard);
        let gender = base.getGenderByIdNumber(this.form.idCard);
        this.$set(this.form, "birthday", birthday);
        this.$set(this.form, "gender", gender);
      } else {
        this.$set(this.form, "birthday", "");
        this.$set(this.form, "gender", 1);
      }
    },
    /**获取名单数据 */
    async getMemberUserInfo() {
      const params = {
        ...this.userInfo,
      };
      const { code, data } = await getMemberUser(params);
      if (code == 200) {
        if (data) {
          this.userInfo1 = data;
        } else {
          this.userInfo1 = {};
        }

        if (this.$route.query.queryActived) {
          this.actived = this.$route.query.queryActived;
          const data = {
            id: Number(this.$route.query.queryActived),
          };
          this.onChangeHospital(data);
        }
      }
    },

    /**获取国籍列表 */
    async getCountryList() {
      const { code, data } = await getCountryListRequest();
      if (code == 200) {
        if (data) {
          this.countryOptions = data;
        } else {
          this.countryOptions = [];
        }
      }
    },
    callback(v) {
      this.pageNum3 = 1;
      this.serviceList = [];
      this.getServiceList();
    },
    birthdayChange(e) {
      let birthday = base.timeSwitch(e._d);
      this.$set(this.form, "birthday", birthday);
    },
    //新增就诊人
    onAddPatient() {
      this.visible = true;
      this.form = {};
      this.$refs["ruleForm"].resetFields();
    },
    //修改就诊人
    onEditPatient(item) {
      this.form = {
        ...item,
        idCard: item.idNumber,
        patientName: item.name,
        birthday: item.birthday.split(" ")[0],
      };
      this.visible = true;
    },
    onAddService() {
      this.isAddService = true;
      this.serviceForm = {
        content: "",
      };
    },
    disabledTime(time) {
      return new Date().getTime() >= new Date(time).getTime();
    },
    onChange(val) {
      this.currentpage = val;
      this.getOppointmentRecord();
    },
    onChange1(val) {
      this.currentpage1 = val;
      this.getReserve();
    },
    onChange2(val) {
      this.currentpage2 = val;
      this.getEndoscopyList();
    },
    servicePageChange(val) {
      this.pageNum3 = val;
      this.getServiceList();
    },
    onUpdatedInfo() {
      this.updateForm = JSON.parse(JSON.stringify(this.userInfoDetail)) || {};

      let otherUnit =
        this.updateForm.unit == "浙江大学" ? "" : this.updateForm.unit;

      let unit =
        this.updateForm.unit == "浙江大学" ? this.updateForm.unit : "其他";

      this.$set(this.updateForm, "otherUnit", otherUnit);

      this.$set(this.updateForm, "unit", unit);

      this.$set(
        this.updateForm,
        "country",
        this.updateForm.country ? this.updateForm.country : "40"
      );
      this.$set(
        this.updateForm,
        "maritalStatus",
        this.updateForm.maritalStatus == 4 ? "" : this.updateForm.maritalStatus
      );

      this.isUpdateUser = true;
      this.confirmLoading = false;
    },

    //确认修改个人信息
    handleOk() {
      this.$refs["updateRuleForm"].validate((valid) => {
        if (valid) {
          this.updateUserInfoFn();
        } else {
          return false;
        }
      });
    },
    //取消修改个人信息
    handleCancel() {
      this.$refs["updateRuleForm"].resetFields();
      setTimeout(() => {
        this.isUpdateUser = false;
      }, 200);
    },

    cancelService() {
      this.$refs["serviceForm"].resetFields();
      setTimeout(() => {
        this.isAddService = false;
      }, 200);
    },

    cancelVisible() {
      this.$refs["ruleForm"].resetFields();
      setTimeout(() => {
        this.visible = false;
      }, 200);
    },

    /**修改个人信息接口 */
    async updateUserInfoFn() {
      this.confirmLoading = true;
      const params = {
        ...this.updateForm,
        unit:
          this.updateForm.unit == "其他"
            ? this.updateForm.otherUnit
            : this.updateForm.unit,
        encrVa: base.encryptAES(this.updateForm.userName + this.updateForm.phone + this.updateForm.userNo),
      };

      const { code, data } = await updateUserInfo(params);
      this.confirmLoading = false;
      if (code == 200) {
        sessionStorage.setItem("token", data.token);
        sessionStorage.setItem("userInfo", JSON.stringify(data.e));
        this.getUserInfo();
        if (this.$route.query.type == 'updateList' && this.userInfo1 && this.userInfo1.id) {
          let updateData = {
            ...this.userInfo1,
            maritalStatus: params.maritalStatus,
            country: params.country,
          }
          this.updateMemberUserInfo(updateData)
        } else {
          this.$message.success("修改成功");
          this.isUpdateUser = false;

        }
      }
    },
    /**更新部分名单信息 */
    async updateMemberUserInfo(params) {
      const { code, data } = await updateMemberUser(params);
      if (code == 200) {
        this.isUpdateUser = false;
        this.$message.success("修改成功")
      }
    },
    // 体检预约-取消
    onCancelReserve(item) {
      // this.$confirm({
      //   title: "取消预约",
      //   content: "取消预约请联系体检老师",
      //   onOk() {
      //     console.log("OK");
      //   },
      //   onCancel() {
      //     console.log("Cancel");
      //   },
      // });

      const _self = this;
      this.$confirm({
        title: "取消预约",
        content: "仅可自行取消预约一次，确认是否取消",
        async onOk() {
          let data = {
            ...item,
            encryptId: base.encryptAES(item.id),
            userNo:sessionStorage.getItem('userInfo')?JSON.parse(sessionStorage.getItem('userInfo')).userNo:"",
          };
          const { code } = await getReserveCancel(data);
          if (code == 200) {
            _self.$message.success("取消预约成功");
            await _self.getReserve();
          }
        },
        async onCancel() { },
        class: "test",
      });
    },
    //取消内镜预约
    onCancelEndoscopy(item) {
      const _self = this;
      const params = {
        id: item.endoscopyId,
        status: "1",
      };
      this.$confirm({
        title: "是否确认取消预约？",
        content: "",
        async onOk() {
          const { code } = await getEndoscopyCancel(params);
          if (code == 200) {
            _self.endoscopyList = [];
            _self.$message.success("取消预约成功");
            await _self.getEndoscopyList();
          }
        },
        async onCancel() { },
        class: "test",
      });
    },

    //获取取号密码
    async showPasswordNumber(item, i) { },

    // 取消预约
    onCancel(item) {
      //sourceType 0-老系统   1-新系统
      let params = {
        ...item,
      };
      const _self = this;
      this.$confirm({
        title: "是否确认取消预约？",
        content: "",
        async onOk() {
          if (item.sourceType == 0) {
            const { code } = await cancelOppointment(params);
            if (code == 200) {
              _self.$message.success("取消预约成功");
              await _self.getOppointmentRecord();
            }
          } else {
            params = {
              organizationId: item.organizationId,
              passwordNumber: base.encryptAES(item.passwordNumber),
              YINGYONGMC: item.campusName,
              YINGYONGID: item.campusId,
            };
            const { code } = await cancelOppointmentV2(params);
            if (code == 200) {
              _self.$message.success("取消预约成功");
              await _self.getOppointmentRecord();
            }
          }
        },
        async onCancel() { },
        class: "test",
      });
    },
    //预约挂号记录
    async getOppointmentRecord() {
      // const params = {
      //   appointmentName: "",
      //   campusName: "",
      //   cardNo: this.userInfo.idCard,
      //   doctorName: "",
      //   medicalRecordsNo: "",
      //   officeName: "",
      //   phoneNumber: this.userInfo.phone,
      //   pageNum: this.currentpage,
      //   pageSize: 10,
      //   restHome: "",
      // };
      // const { code, data } = await oppointmentRecord(params);
      let params = {
        pageNum: this.currentpage,
        pageSize: 10,
      };
      let { code, data, total } = await userListAppointment(params);
      if (code == 200) {
        this.listData = data;
        this.total = total;
        if (data.length > 0) {
          this.isNo = false;
        } else {
          this.isNo = true;
        }
      } else {
        this.isNo = true;
      }
    },
    //体检记录
    async getReserve() {
      const params = {
        name: this.userInfo1.name,
        phone: this.userInfo1.phone,
        idNumber: this.userInfo1.idNumber, //证件号
        pageNum: this.currentpage1, //页码 默认为1
        pageSize: 10, //每页记录数 默认为10
        encrVa: base.encryptAES(this.userInfo1.name + this.userInfo1.idNumber + this.userInfo.userNo),//加密字段
      };
      const { code, data, total } = await getReserveList(params);
      if (code == 200) {
        this.listData1 = data;
        this.total1 = total;

        if (data.length > 0) {
          this.isNo = false;
        } else {
          this.isNo = true;
        }
      } else {
        this.isNo = true;
      }
    },
    //内镜记录
    async getEndoscopyList() {
      const params = {
        userNo: this.userInfo.userNo,
        name: this.userInfo.userName,
        idCard: this.userInfo.idCard,
        // restHome: 'string',
        pageNum: this.currentpage2, //页码 默认为1
        pageSize: 10, //每页记录数 默认为10
      };
      const { code, data, total } = await getEndoscopy(params);
      if (code == 200) {
        this.total2 = total;
        this.endoscopyList = data;
        if (data && data.length > 0) {
          this.isNo = false;
        } else {
          this.isNo = true;
        }
      } else {
        this.isNo = true;
        this.endoscopyList = [];
        this.total2 = 0;
      }
    },
    //就诊人列表
    async listPatients() {
      if (this.userInfo.userNo) {
        const params = {
          userNo: this.userInfo.userNo,
          // name: this.userInfo.userName,
          // idCard: this.userInfo.idCard,
          // pageNum: this.currentpage2, //页码 默认为1
          // pageSize: 10 //每页记录数 默认为10
        };
        const { code, data, total } = await getListPatients(params);
        if (code == 200) {
          this.listPatient = data;
          if (data && data.length > 0) {
            this.isNo = false;
          } else {
            this.isNo = true;
          }
        } else {
          this.isNo = true;
          this.listPatient = [];
        }
      }
    },
    //服务工单列表
    async getServiceList() {
      const params = {
        status: this.serviceStatus,
        pageNum: this.pageNum3, //页码 默认为1
        pageSize: 10, //每页记录数 默认为10
      };
      const { code, data, total } = await getServiceListRequest(params);
      if (code == 200) {
        this.serviceList = data;
        this.serviceTotal = total;
        if (data && data.length > 0) {
          this.isNo = false;
        } else {
          this.isNo = true;
        }
      } else {
        this.isNo = true;
        this.serviceList = [];
        this.serviceTotal = 0;
      }
    },

    /**获取用户信息 */
    async getUserInfo() {
      let userId = this.userInfo.userNo;

      const { code, data } = await getUserDetail(userId);
      if (code == 200) {
        this.userInfoDetail = data;
        this.isNo = false;
      }
    },
    //删除服务工单
    deleteItem(id) {
      let that = this;
      this.$confirm({
        title: "确认删除此服务工单？",
        content: "",
        onOk() {
          that.deleteServiceList(id);
        },
        onCancel() { },
        class: "test",
      });
    },
    async deleteServiceList(id) {
      const params = {
        id,
      };
      const { code, data, total } = await deleteServiceRequest(params);
      if (code == 200) {
        this.pageNum3 = 1;
        this.serviceList = [];
        this.getServiceList();
      }
    },
    //就诊人提交
    onSubmit() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          let params = {
            ...this.form,
            birthday: this.form.birthday + " 00:00:00",
            userNo: this.userInfo.userNo,
          };

          if (params.id) {
            //修改
            const { code, data } = await editPatient(params);
            if (code == 200) {
              this.$message.success("编辑成功");
              this.listPatients();
              this.visible = false;
            }
          } else {
            //新增
            const { code, data } = await addPatient(params);
            if (code == 200) {
              this.$message.success("新增成功");
              this.listPatients();
              this.visible = false;
            }
          }
        }
      });
    },
    //新增服务工单提交
    async onSubmitService() {
      this.$refs.serviceForm.validate(async (valid) => {
        if (valid) {
          const params = {
            ...this.serviceForm,
            userNo: this.userInfo.userNo,
          };
          const { code, data } = await addServiceRequest(params);
          if (code == 200) {
            this.$message.success("新增成功");
            this.getServiceList();
            this.isAddService = false;
          }
        }
      });
    },

    //删除就诊人信息
    async onDelPatient(item) {
      const _self = this;
      this.$confirm({
        title: "是否确认删除就诊人信息？",
        content: "",
        async onOk() {
          const { code, data } = await deletePatient(item.id);
          if (code == 200) {
            _self.$message.success("删除成功");
            _self.listPatients();
          }
        },
        async onCancel() { },
        class: "test",
      });
    },

    onChangeHospital(data) {
      this.actived = data.id;

      switch (data.id) {
        case 0:
          this.getOppointmentRecord();
          break;
        case 1:
          this.getReserve();
          break;
        case 2:
          this.getEndoscopyList();
          break;
        case 3:
          this.$router.push({ path: "/report" });
          break;
        case 4:
          this.$router.push({ path: "/report", query: { type: 2 } });
          break;
        case 5:
          this.$router.push({ path: "/medicalReport" });
          break;
        case 6:
          this.$router.push({ path: "/chat" });
          break;
        case 7:
          this.listPatients();
          break;
        case 8:
          this.getServiceList();
          break;
        case 9:
          this.getUserInfo();
          break;
        default:
          break;
      }
    },
    onChangeDepartment(index, data) {
      this.activedDepartment = index;
    },
    countryFormatter(code) {
      let val = this.countryOptions.filter((e) => e.countryCode == code);
      if (val.length > 0) {
        return val[0].countryName;
      }
    },
  },
  filters: {
    statusFilter(v) {
      if (v === 1) {
        return "未处理";
      } else {
        return "已处理";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.displayShow {
  display: auto;
}

.displayNone {
  display: none;
}

.fontColor {
  color: #3f86ff;
  font-size: 14px;
}

.fontstyle {
  font-size: 14px;
  cursor: pointer;
}

.container {
  .select {
    .title {
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      padding-right: 30px;

      h3 {
        font-size: 20px;
      }

      .line {
        width: 100px;
        height: 2px;
        background: #000;
      }
    }
  }

  .select-box {
    display: flex;
    justify-content: center;
    background: #ffffff;
    margin-top: 20px;

    .select-hospital {
      width: 276px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      border: 1px solid #e3e3e3;

      .menu-header {
        width: 276px;
        height: 289px;
        text-align: center;
        background-image: url("../assets/img/user-header.png");
        background-size: 100%;
        background-repeat: no-repeat;

        img {
          margin-top: 50px;
          width: 100px;
          height: 100px;
          border-radius: 50%;
        }

        .name {
          margin-top: 14px;
          height: 22px;
          font-size: 16px;
          font-weight: 400;
          color: #333333;
          line-height: 22px;
        }
      }

      .hospital-title {
        span {
          font-size: 20px;
          font-weight: 600;
        }

        font-size: 20px;
        padding: 12px 0;
        font-weight: 600;
        padding-left: 25%;
      }

      .hospital-item {
        cursor: pointer;
        height: 51px;
        box-sizing: border-box;
        font-size: 18px;
        line-height: 51px;
        padding-left: 35%;
        color: #999999;
      }

      margin-right: 20px;
    }

    .select-department {
      // padding: 20px;
      flex: 3;

      // border: 2px solid #f8f8f8;
      .list {
        &-item {
          position: relative;
          // width: 674px;
          background: inherit;
          background-color: #fff;
          box-sizing: border-box;
          margin-bottom: 20px;
          box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
          border: 1px solid rgba(0, 0, 0, 0.1);

          .list-item-top {
            height: 51px;
            border-bottom: 1px solid #e3e3e3;
            padding: 0 20px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .name {
              font-size: 16px;
            }

            .status {
              font-size: 14px;
            }
          }

          .list-item-content {
            position: relative;
            padding: 20px;

            >div {
              margin: 5px 0;
              font-size: 14px;
            }
          }

          .btn {
            margin-left: 20px;
            margin-bottom: 20px;
          }

          .pwd {
            position: absolute;
            right: 20px;
            top: 20px;
          }
        }
      }
    }
  }

  .actived {
    color: #3f86ff !important;
    border-bottom: 1px solid #3f86ff;
    background-color: rgba(63, 134, 255, 0.07) !important;
  }

  .activedDepartmentStyle {
    color: #3f86ff;
    cursor: pointer;
  }
}
</style>
